import { ReactNode, FC, createContext, useState, useMemo } from 'react';

const LoadingContext = createContext<any>({});

type LoadingProps = {
  children: ReactNode;
};

const Loading: FC<LoadingProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const loadingProviderValue = useMemo(
    () => ({ isLoading, setIsLoading }),
    [isLoading, setIsLoading],
  );

  return (
    <LoadingContext.Provider value={loadingProviderValue}>
      {children}
    </LoadingContext.Provider>
  );
};

export { Loading, LoadingContext };
